// src/components/TeamQrScanner.jsx
//
// Kamera-Scanner fuer den QR-Code auf dem Team-Laufzettel. Der Code kodiert
// bereits `<frontend-url>/team/<share_token>` (siehe functions/pdf/data.js) –
// dieser Dialog liest nur den Text aus der Kamera, das Zuordnen zum Team
// passiert im Aufrufer, der die ohnehin geladene Teamliste kennt.
import { useEffect, useRef, useState } from "react";
import { Html5Qrcode } from "html5-qrcode";
import Modal from "./ui/Modal";

const VIEWPORT_ID = "team-qr-scanner-viewport";

export default function TeamQrScanner({ open, onClose, onScan }) {
  const [error, setError] = useState(null);
  // Ref statt Abhaengigkeit im Effekt: eine neue Funktionsidentitaet von
  // onScan bei jedem Render soll die laufende Kamera nicht neu starten.
  const onScanRef = useRef(onScan);
  onScanRef.current = onScan;

  useEffect(() => {
    if (!open) return;
    setError(null);

    const scanner = new Html5Qrcode(VIEWPORT_ID);
    // Ob start() die Kamera tatsaechlich erfolgreich uebernommen hat – ohne
    // das wirft scanner.stop() synchron ("Cannot stop, scanner is not
    // running or paused."), z. B. wenn der Kamerazugriff verweigert wurde.
    let running = false;
    let stopped = false;

    scanner
      .start(
        { facingMode: "environment" },
        { fps: 10, qrbox: { width: 220, height: 220 } },
        (decodedText) => {
          if (stopped) return;
          stopped = true;
          onScanRef.current(decodedText);
        },
        () => {
          // Wird pro erfolglosem Frame aufgerufen (kein Code im Bild) – normal
          // waehrend des Ausrichtens, keine Fehlermeldung noetig.
        }
      )
      .then(() => {
        running = true;
        // Dialog wurde bereits geschlossen, waehrend start() noch lief –
        // ohne diesen Nachtrag bliebe die Kamera offen.
        if (stopped) scanner.stop().then(() => scanner.clear()).catch(() => {});
      })
      .catch(() => {
        setError(
          "Kamera konnte nicht gestartet werden. Bitte Zugriff erlauben oder das Team unten manuell auswählen."
        );
      });

    return () => {
      stopped = true;
      if (!running) return;
      scanner.stop().then(() => scanner.clear()).catch(() => {});
    };
  }, [open]);

  return (
    <Modal open={open} onClose={onClose} title="Team-QR-Code scannen">
      {error ? (
        <div className="p-3 bg-red-800 text-red-200 rounded">{error}</div>
      ) : (
        <div id={VIEWPORT_ID} className="w-full rounded-lg overflow-hidden" />
      )}
      <div className="text-xs text-secondary-400 text-center">
        QR-Code auf dem Laufzettel vor die Kamera halten.
      </div>
    </Modal>
  );
}
